import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { ConfigurationService } from '@services/configuration.service';

import { Banner, BannerLocation } from '@interfaces/directus-cms.interface';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class GraphQLRepository {
    protected config: ConfigurationService = inject(ConfigurationService);
    protected http: HttpClient = inject(HttpClient);
    protected document: Document = inject(DOCUMENT);

    public query(query: string, scope: string): Observable<any> {
        const url = this.config.getData()?.global.graphQL.url;

        // Add generic headers :
        const headers = new HttpHeaders()
            .set('X-Source', this.document.defaultView.ConfigInitial?.oauth?.xSource)
            .set('Content-Type', 'application/json')
            .set('X-Graphql-Scope', scope);

        return this.http.post(url, { query }, { headers });
    }

    public getBannersForSlug(querySlugParam: string): Observable<Banner> {
        const query: string = `
            {
                getBannersLocation {
                    items @SPL(query: "slug IN ['${querySlugParam}']"){
                        banners {
                            items {
                                background_img
                                background_choice_img_kv
                                sticker_value
                                sticker_value_mobile
                                icon
                                title_logo
                                title
                                title_mobile
                                mentions
                                subtitle
                                inverted_content_desktop
                            }
                        }
                    }
                }
            }`;

        return this.query(query, this.config.getData()?.global.graphQL.scope).pipe(
            map(({ data }: BannerLocation): Banner => {
                const banner = data?.getBannersLocation.items[0]?.banners.items[0];
                return { ...banner, icon: banner?.icon ? banner?.icon.replace(/[\[\]]+/g, '').split(',') : null };
            }),
        );
    }
}
